import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { EventTableColumns } from "../../../../event/domain/columns/EventTableColumns";
import { eventSchema } from "../../../../event/domain/schema/eventSchema";
import { useTranslatedColumns } from "../../../../general/modules/commons/tableTranslation/translatedColumns";
import useCrudFilters from "../../../../../hooks/useCrudFilters";

interface CarEventsModalProps {
  carLicence: string;
}

export const CarEventsModal: React.FC<CarEventsModalProps> = ({
  carLicence,
}) => {
  const { t } = useTranslation("common");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const translatedColumns = useTranslatedColumns(EventTableColumns);

  const carEventsFilter = useCrudFilters(
    {
      searchBy: "SearchByRootEvent",
      fields: {
        hidden: {
          equal: false,
        },
        tireset: {
          fields: {
            car: {
              fields: {
                licence: {
                  in: [carLicence.replace(/-/g, "").toUpperCase()],
                },
              },
            },
          },
        },
      },
    },
    "carEventsFilter",
  );

  const crud = useCrudTable({
    prefix: "events",
    entity: "Event",
    columns: translatedColumns,
    schema: eventSchema,
    filters: carEventsFilter.filters,
    defaultSorting: [
      {
        id: "created_at",
        desc: true,
      },
    ],
  });

  return (
    <>
      <Button variant="outline-primary" onClick={handleShow}>
        {t("View events")}
      </Button>

      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{t("Car Events")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{crud.table}</Modal.Body>
      </Modal>
    </>
  );
};
